// extracted by mini-css-extract-plugin
export default {"category_div":"Home_category_div__qlYg3","main":"Home_main__Q+1Mi","carousel":"Home_carousel__BQSzf"};